@if (dataSource.data) {
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="logic-tree">
	<!-- Expandable nodes -->
	<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
		<ul>
			<li>
				<div class="mat-tree-node" [ngClass]="{ 'logic-tree--complete': node.isComplete }">
					<button
						mat-button
						cm-mini-button
						matTreeNodeToggle
						[attr.aria-expanded]="treeControl.isExpanded(node)"
						[matTooltip]="
							treeControl.isExpanded(node)
								? ('Close folder'
								  | cmLocalize: 'Credential/System.LogicTree.Button.Opened')
								: ('Open folder'
								  | cmLocalize: 'Credential/System.LogicTree.Button.Closed')
						"
						[attr.aria-label]="
							node.isComplete
								? ('Complete'
								  | cmLocalize: 'Credential/System.LogicTree.Content.Complete')
								: ('Incomplete'
								  | cmLocalize: 'Credential/System.LogicTree.Content.Incomplete')
						">
						@if (node.isComplete) {
						<ats-icon
							name="folder-checked"
							[title]="
								'Complete'
									| cmLocalize: 'Credential/System.LogicTree.Content.Complete'
							">
						</ats-icon>
						} @else { @if (treeControl.isExpanded(node)) {
						<ats-icon name="folder-open"></ats-icon>
						} @if (!treeControl.isExpanded(node)) {
						<ats-icon name="folder-closed"></ats-icon>
						} }
					</button>
					@if (node.externalId) {
					<span>
						{{ node.externalId }}
					</span>
					<span class="logic-tree--left-margin"> - </span>
					}
					<span
						class="logic-tree--left-margin"
						cmLocalize="Credential/System.LogicTree.Content.Required">
						Required:
					</span>
					<span class="logic-tree--left-margin">
						@if (node.numRequired === 0) {
						<span cmLocalize="Core/System.Global.Content.All">All</span>
						({{ node.numChildren }}) } @else {
						<span>{{ node.numRequired }}</span>
						}
					</span>
					@if (node.earnedPoints) {
					<span
						class="logic-tree--left-margin"
						cmLocalize="Credential/System.LogicTree.Content.Completed">
						Completed:
					</span>
					<span class="logic-tree--left-margin">
						{{ node.earnedPoints }}
					</span>
					} @if (node.label) {
					<span> &nbsp;&ndash; {{ node.label }} </span>
					}
				</div>

				@if (treeControl.isExpanded(node)) {
				<div class="logic-tree--indent" role="group">
					<ng-container matTreeNodeOutlet></ng-container>
				</div>
				}
			</li>
		</ul>
	</mat-nested-tree-node>

	<!-- Leaf nodes -->
	<mat-tree-node *matTreeNodeDef="let node">
		<ul>
			<li class="logic-tree__leaf">
				<span>
					@if (node.maxPoints !== null && (node.maxPoints > 0 || node.earnedPoints)) {
					<span class="logic-tree__points">
						@if (node.maxPoints > 0) {
						<span cmLocalize="Credential/System.LogicTree.Content.Max"> Max: </span>
						<span class="logic-tree--left-margin">
							{{ node.maxPoints }}
						</span>
						} @if (node.earnedPoints) {
						<span
							class="logic-tree--left-margin"
							cmLocalize="Credential/System.LogicTree.Content.Completed">
							Completed:
						</span>
						<span class="logic-tree--left-margin">
							{{ node.earnedPoints }}
						</span>
						}
					</span>
					} @if (node.label) {
					<span> &nbsp;&ndash; {{ node.label }} </span>
					}

					<span
						class="logic-tree__name"
						[ngClass]="{
							'logic-tree--complete': node.isComplete,
							'logic-tree--top-margin': !(
								node.maxPoints !== null &&
								(node.maxPoints > 0 || node.earnedPoints)
							)
						}">
						@if (catalog) {
						<ats-icon class="logic-tree__dash" name="dash" [size]="8"> </ats-icon>
						} @else { @if (node.isComplete) {
						<ats-icon
							name="circle-check"
							[title]="
								'Complete'
									| cmLocalize: 'Credential/System.LogicTree.Content.Complete'
							">
						</ats-icon>
						} @else {
						<ats-icon
							name="circle"
							[title]="
								'Incomplete'
									| cmLocalize: 'Credential/System.LogicTree.Content.Incomplete'
							">
						</ats-icon>
						} }

						{{ formatLeafName(node) }}

						@if (node.startDate) {
						<span class="ml-4">
							&mdash;
							<span cmLocalize="Credential/System.LogicTree.Content.Starts">
								Starts </span
							>:
							{{ node.startDate | cmDate }}
						</span>
						} @if (node.endDate) {
						<span>
							@if (node.startDate) { , }
							<span cmLocalize="Credential/System.LogicTree.Content.Ends"> Ends </span
							>:
							{{ node.endDate | cmDate }}
						</span>
						} @if (!catalog) {
						<span class="cdk-visually-hidden">
							{{
								node.isComplete
									? ('Complete'
									  | cmLocalize: 'Credential/System.LogicTree.Content.Complete')
									: ('Incomplete'
									  | cmLocalize: 'Credential/System.LogicTree.Content.Incomplete')
							}}
						</span>
						}
					</span>
				</span>

				@if (node.usedItemList?.length || node.examCatalog?.schedulingUrl) {
				<span
					class="logic-tree__info"
					[ngClass]="{
						'logic-tree--top-margin':
							node.maxPoints !== null && (node.maxPoints > 0 || node.earnedPoints)
					}">
					@if (node.usedItemList?.length) {
					<button
						mat-button
						cm-mini-button
						[cmOverlayTriggerFor]="completedData"
						[matTooltip]="
							('Info for' | cmLocalize: 'Credential/System.LogicTree.Button.Info') +
							' ' +
							formatLeafName(node)
						"
						[attr.aria-label]="
							('Info for' | cmLocalize: 'Credential/System.LogicTree.Button.Info') +
							' ' +
							formatLeafName(node)
						">
						<ats-icon name="info"> </ats-icon>
					</button>
					} @if (node.examCatalog?.schedulingUrl) {
					<!-- This is protected by the Exam.SchedulingUrl feature -->
					<a
						mat-button
						cm-mini-button
						[href]="node.examCatalog?.schedulingUrl"
						target="_blank"
						[matTooltip]="
							'Schedule Exam'
								| cmLocalize: 'Credential/System.LogicTree.Button.Schedule'
						"
						[attr.aria-label]="
							'Schedule Exam'
								| cmLocalize: 'Credential/System.LogicTree.Button.Schedule'
						">
						<ats-icon name="calendar"> </ats-icon>
					</a>
					}
				</span>
				}
			</li>
		</ul>

		<cm-context-overlay #completedData="cmOverlay">
			<h2 cm-overlay-title>{{ formatLeafName(node) }}</h2>
			<div>
				@for (usedItem of node.usedItemList; track usedItem; let i = $index) {
				<ul [ngClass]="{ 'logic-tree__item': i !== node.usedItemList.length - 1 }">
					<li>
						<span cmLocalize="Credential/System.LogicTree.Content.Active">
							Active:
						</span>
						<span class="logic-tree--left-margin">
							{{
								usedItem.cert?.activeDate ||
									usedItem.exam?.dateTime ||
									usedItem.certRequirement?.activeDate | cmDate
							}}
						</span>
					</li>
					@if (usedItem.cert?.inactiveDate) {
					<li>
						<span cmLocalize="Credential/System.LogicTree.Content.Inactive">
							Inactive:
						</span>
						<span class="logic-tree--left-margin">
							{{
								(usedItem.cert?.inactiveDate | cmDate) ||
									('Never'
										| cmLocalize: locFeature + '/System.Global.Content.Never')
							}}
						</span>
					</li>
					} @if (node.pointsPerItem || usedItem.certRequirement) {
					<li>
						<span cmLocalize="Credential/System.LogicTree.Content.Points">
							Points:
						</span>
						<span class="logic-tree--left-margin">
							{{ usedItem.points }}
						</span>
					</li>
					} @if (usedItem.certRequirement?.provider) {
					<li>
						<cm-localize
							[name]="locs.SPCertLogicTreeProvider"
							[cpName]="locs.CPCertLogicTreeProvider">
						</cm-localize
						>:
						<span class="logic-tree--left-margin">
							{{ usedItem.certRequirement?.provider }}
						</span>
					</li>
					} @if (usedItem.exam?.catalog?.externalId && node.examGroup) {
					<li>
						<cm-localize
							[name]="locs.SPCertLogicTreeExternalId"
							[cpName]="locs.CPCertLogicTreeExternalId">
						</cm-localize
						>:
						<span class="logic-tree--left-margin">
							{{ usedItem.exam?.catalog?.externalId }}
						</span>
					</li>
					} @if (usedItem.exam?.catalog?.name && node.examGroup) {
					<li>
						<cm-localize
							[name]="locs.SPCertLogicTreeName"
							[cpName]="locs.CPCertLogicTreeName">
						</cm-localize
						>:
						<span class="logic-tree--left-margin">
							{{ usedItem.exam?.catalog?.name }}
						</span>
					</li>
					}
				</ul>
				}
			</div>
		</cm-context-overlay>
	</mat-tree-node>
</mat-tree>
}
